<div class="body" [class.clickable]="clickable" (click)="onClick()">
    <span class="fiv-sqo file-icon" [ngClass]="fileType"></span>
    <div class="content">
        <span class="filename">
            {{fileName|nextcloud}}
        </span>
        <span class="size">
            {{fileSize}}
        </span>
    </div>
    <mat-icon *ngIf="showPreviewIcon" class="control-icon" matTooltip="Vorschau" (click)="downloadAndPreview($event)">search</mat-icon>
    <mat-icon *ngIf="showDownloadIcon" class="control-icon" matTooltip="Download" (click)="downloadAndPreview($event)">cloud_download</mat-icon>
    <mat-icon *ngIf="showUploadNow" class="control-icon" matTooltip="Jetzt hochladen" (click)="uploadNow($event)">cloud_upload</mat-icon>
    <mat-icon *ngIf="showRemover" class="control-icon remove" matTooltip="Löschen" (click)="remove($event)">delete_forever</mat-icon>
    <mat-icon *ngIf="showOptionsMenu" class="control-icon" matTooltip="Optionen" (click)="$event.stopPropagation()" [matMenuTriggerFor]="optionsMenu">more_horiz</mat-icon>
</div>

<mat-menu #optionsMenu="matMenu">
    <button mat-menu-item class="dropdown-item" (click)="rename()">
        <mat-icon class="dropdown-icon">edit</mat-icon>
        <span>Umbenennen</span>
    </button>
    <button mat-menu-item class="dropdown-item" (click)="move()">
        <mat-icon class="dropdown-icon">swap_calls</mat-icon>
        <span>Verschieben</span>
    </button>
    <button mat-menu-item class="dropdown-item" (click)="remove()">
        <mat-icon class="dropdown-icon">delete_forever</mat-icon>
        <span>Löschen</span>
    </button>
</mat-menu>